// extracted by mini-css-extract-plugin
export default {"root":"jnPSR","chevronRightIcon":"_3x2uX"};